module.exports = __webpack_public_path__ + "img/cover.0e9fa9c1.png";